// @flow

// $FlowFixMe: useState is not supported by flow in GHR. Remove once GHR has a flow version > 0.87
import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../constants';

const RADIUS_VALUES = { circle: '50%', square: '2px' };
const SIZE_VALUES = { medium: '32px', large: '50px' };

function partnerAbbreviation(name) {
  const [firstWord = '', secondWord = ''] = name.split(' ');
  const abbreviation = firstWord.charAt(0) + secondWord.charAt(0);
  return abbreviation.toUpperCase();
}

type Props = {
  name: string,
  shape?: 'circle' | 'square',
  size?: 'medium' | 'large',
  iconUrl?: string,
};

const PartnerIcon = (props: Props) => {
  const { name, shape, size, iconUrl } = props;

  const [useIcon, setUseIcon] = useState(iconUrl != undefined);

  const onError = () => {
    setUseIcon(false);
  };

  const onLoad = (e) => {
    const height = e.currentTarget.naturalHeight;
    const width = e.currentTarget.naturalWidth;

    const margin = height * 0.25;
    const isValidSize = width > height - margin && width < height + margin;

    if (!isValidSize) {
      setUseIcon(false);
    }
  };

  return (
    <IconContainer shape={shape} size={size} iconPresent={useIcon}>
      {useIcon ? (
        <IconImage src={iconUrl} onError={onError} onLoad={onLoad} />
      ) : (
        <IconPlaceholder>{partnerAbbreviation(name)}</IconPlaceholder>
      )}
    </IconContainer>
  );
};

PartnerIcon.defaultProps = {
  shape: 'square',
  size: 'medium',
};

export default PartnerIcon;

const IconContainer = styled.div`
  align-items: center;
  background-color: ${({ iconPresent }) =>
    iconPresent ? 'transparent' : colors.lightGreenhouseGreen};
  border-radius: ${({ shape }) => RADIUS_VALUES[shape]};
  display: inline-flex;
  height: ${({ size }) => SIZE_VALUES[size]};
  justify-content: center;
  width: ${({ size }) => SIZE_VALUES[size]};
`;

const IconImage = styled.img`
  border-radius: inherit;
  height: inherit;
  width: inherit;
`;

const IconPlaceholder = styled.span`
  color: ${colors.darkestGrey};
  font-size: ${fontSize.large};
  font-weight: ${fontWeight.normal};
`;
